<app-vwo-capturer></app-vwo-capturer>
<ng-container *ngIf="!(cmsService.loaded$ | async)">
    <p class="loading">Loading <span>.</span><span>.</span><span>.</span></p>
</ng-container>
<ng-container *ngIf="cmsService.loaded$ | async">
    <app-menu class="d-block" fit-children-height></app-menu>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
    <app-cms-keys-bar></app-cms-keys-bar>
</ng-container>
